import React from 'react';
import { Modal, Form, DatePicker, Select } from 'antd';

const monthOptions = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

const ReportsModal = ({ visible, onCancel, onOk }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then((values) => {
      // console.log("values", values);
      const formattedValues = {
        ...values,
        year: values.year.year(),
      };
      onOk(formattedValues);
      form.resetFields(); 
    }).catch(() => {
      
    });
  };

  const handleCancel = () => {
    form.resetFields(); 
    onCancel();
  };

  return (
    <Modal
      title="Generate Report"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Generate"
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          name="month"
          label="Month Name"
          rules={[{ required: true, message: 'Please select a month' }]}
        >
          <Select
            options={monthOptions}
            placeholder="Select month"
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Form.Item
          name="year"
          label="Year"
          rules={[{ required: true, message: 'Please select a year' }]}
        >
          <DatePicker
            picker="year"
            style={{ width: '100%' }}
            placeholder="Select year"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReportsModal;